import Input from '@taglivros/oef_componentes/build/components/input'


import React from 'react'
import { func } from 'prop-types'

const NumberInput = ( { onKeyPress, ...props } ) => {
  const handleKeyPress = ( event ) => {
    const keyCode = event.keyCode || event.which
    const keyValue = String.fromCharCode( keyCode )

    if ( !( /^[0-9]+$/u ).test( keyValue ) && keyCode !== 13 ) {
      event.preventDefault()
    }

    if ( onKeyPress ) {
      onKeyPress( event )
    }
  }

  return (
    <Input
      onKeyPress={ handleKeyPress }
      { ...props }
    />
  )
}

NumberInput.propTypes = {
  'onKeyPress': func
}

NumberInput.defaultProps = {
  'onKeyPress': null
}

export default NumberInput

